import React, { useState, useEffect, useContext } from 'react';
import { axios } from '../services/ServiceUtils';
import { useLanguageContext } from './LanguageContext';

const SendUsMessageContext = React.createContext();
export const useSendUsMessageContext = () => useContext(SendUsMessageContext);

const { Provider } = SendUsMessageContext;

const SendUsMessageProvider = ({ children }) => {
  const [sendUsMessage, setSendUsMessage] = useState({
    title: '',
    description: '',
    formLabels: {},
    contactUslink: '',
    submitting: false,
    submitted: false,
    error: false,
    questions: [],
  });

  const { language } = useLanguageContext();

  const sendMessage = (caseInfo, onSendMessage) => {
    setSendUsMessage(state => ({
      ...state,
      submitting: true,
      submitted: false,
      error: false,
    }));

    if (language.locale.split('-')[1].toUpperCase() === 'US') {
      // Case creation to US directly on Salesforce
      axios
        .post('api/customercare', { caseInfo: { ...caseInfo } })
        .then(req => onSendMessage(req.data))
        .catch(() => {
          const error = true;
          onSendMessage({ error });
          setSendUsMessage(state => ({ ...state, error }));
        })
        .finally(() => {
          setSendUsMessage(state => ({ ...state, submitting: false, submitted: true }));
        });
    } else {
      // Case creation through RabbitMQ
      let question = caseInfo.questionValue;
      let type, subType;
      if (
        question.includes('subject-04-question-01') ||
        question.includes('subject-04-question-02')
      ) {
        type = 'Misdirected Call';
        subType = 'Misdirected Call';
      } else if (
        question.includes('subject-02-question-01')
      ) {
        type = 'General Inquiry';
        subType = 'Basic Product Questions';
      } else if (
        question.includes('subject-05-question-01') ||
        question.includes('subject-05-question-02')
      ) {
        type = 'General Inquiry';
        subType = 'Basic Account Information';
      } else if (
        question.includes('subject-01-question-01')
      ) {
        type = 'Payments';
        subType = 'Basic Payment Question';
      } else if (
        question.includes('subject-01-question-02')
      ) {
        type = 'Online';
        subType = 'Online Profile';
      } else if (
        question.includes('subject-01-question-03')
      ) {
        type = 'Online';
        subType = 'Online General Information';
      } else if (
        question.includes('subject-03-question-01')
      ) {
        type = 'Statement/Invoice Inquiry';
        subType = 'Taxes';
      } else if (
        question.includes('subject-04-question-03')
      ) {
        type = 'Statement/Invoice Inquiry';
        subType = 'Statement/Invoice Summary';
      } else {
        type = 'Other';
        subType = 'Other';
      };

      let body = {
        accountId: '',
        activityType: 'Correspondence',
        callContactName: `${caseInfo.firstName + ' ' + caseInfo.lastName}`,
        callContactEmail: `${caseInfo.emailAddress}`,
        callContactPhone: `${caseInfo.phoneNumber}`,
        caseCountry: 'Canada',
        caseId: '',
        caseLanguage: `${language.locale.split('-')[0].toUpperCase() === 'FR' ? 'French' : 'English'}`,
        caseNumber: '',
        caseOption: `${subType}`,
        correspondenceRequestType: 'Customer Portal',
        description: `${caseInfo.message}`,
        messageIDDocumentNumber: 'Customer Portal',
        origin: 'Customer Portal',
        owner: 'CA Revolving Correspondence',
        priority: 'Normal',
        revolvingAccountNumber: `${caseInfo.dfsAccountNumber}`,
        subType: `${subType}`,
        subject: `${caseInfo.subject}`,
        type: `${type}`
      };
      
      axios
        .post('api/case-management', body)
        .then(req => onSendMessage(req.data))
        .catch(() => {
          const error = true;
          onSendMessage({ error });
          setSendUsMessage(state => ({ ...state, error }));
        })
        .finally(() => {
          setSendUsMessage(state => ({ ...state, submitting: false, submitted: true }));
        });
    }
  };

  useEffect(() => {
    axios
      .get('api/send-us-message', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(({ data }) => {
        setSendUsMessage(state => ({
          ...state,
          ...data,
        }));
      });
  }, [language.locale]);

  useEffect(() => {
    if (language.locale.split('-')[1].toUpperCase() === 'US') {
      axios.get('api/customercare').then(({ data }) => {
        setSendUsMessage(state => ({
          ...state,
          questions: data.questions,
        }));
      });
    } else {
      axios
      .get('api/customer-care/public', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(({ data }) => {
        setSendUsMessage(state => ({
          ...state,
          questions: data.subjects,
        }));
      });
    }
  }, [language.locale]);

  return (
    <Provider
      value={{
        ...sendUsMessage,
        sendMessage,
      }}
    >
      {children}
    </Provider>
  );
};

export { SendUsMessageProvider };
export default SendUsMessageContext;
